/**
 * Process — 진행 절차 4단계 (new design)
 *
 * preview/index.html 의 .process 1:1 매칭
 *  - 4컬럼 (1280 이하 2컬럼, 767 이하 1컬럼)
 *  - 점선 연결선은 CSS .process-steps::before 로 처리
 *  - 하단에 process-notice (벤처기업확인 일정 안내)
 *
 * 데이터: PROCESS_STEPS, PROCESS_NOTICE (config/constants.ts)
 */
import { PROCESS_STEPS, PROCESS_NOTICE } from '@/config/constants';

export function Process() {
  return (
    <section className="process" id="process">
      <div className="section-head">
        <span className="section-tag">PROCESS</span>
        <h2 className="section-title">
          간단한 4단계로<br />
          <span className="accent">인증을 시작하세요</span>
        </h2>
        <p className="section-sub">신청부터 확인서 발급까지 단계별로 안내해드립니다.</p>
      </div>

      <div className="process-inner">
        <div className="process-steps">
          {PROCESS_STEPS.map((step) => (
            <div key={step.num} className="process-step">
              <div className="process-num">{step.num}</div>
              <h3 className="process-step-title">{step.title}</h3>
              <p className="process-step-desc">{step.desc}</p>
              <span className="process-duration">{step.duration}</span>
            </div>
          ))}
        </div>

        <p className="process-notice">{PROCESS_NOTICE}</p>
      </div>
    </section>
  );
}
